
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"59","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"59","height":"59.25","rx":"29.5","fill":"#E6EBFF"}}),_c('g',{attrs:{"clip-path":"url(#clip0_6162_103642)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_6162_103642)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.25 18.278h-1.333v3.333h3V28.5l-5.534 7.378c-1.977 2.637-.096 6.4 3.2 6.4h13.334c3.296 0 5.177-3.763 3.2-6.4L33.583 28.5V21.61h3v-3.333H23.25zm4.333 5v-2.334h3.334v8.445l.266.355 3.4 4.534H23.917l3.4-4.534.266-.355V23.278zm-5.666 13.666l-.4.534c-.66.879-.032 2.133 1.066 2.133h13.334c1.098 0 1.725-1.254 1.066-2.133l-.4-.534H21.917z","fill":"#0037FF"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6162_103642"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(13.25 14)","d":"M0 0h32v32H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_6162_103642"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(13.25 14)","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    